import { render, staticRenderFns } from "./THGTagSelectModal.vue?vue&type=template&id=ee3cddc2&scoped=true"
import script from "./THGTagSelectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGTagSelectModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGTagSelectModal.vue?vue&type=style&index=0&id=ee3cddc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3cddc2",
  null
  
)

export default component.exports